import EventBus from "./event-bus";

const axios = require('axios');

import {errorHandler} from "./common";

export function getVendors(type) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.get(process.env.ROOT_API + 'admin/vendors?type=' + type, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("get Vendor List");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}

export function getVendor(id) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.get(process.env.ROOT_API + 'admin/vendor?id='+id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("get Vendor Item");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}

export function deleteVendor(id) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.delete(process.env.ROOT_API + 'admin/vendor?id='+id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("get Vendor Item");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}

export function updateVendor(merchant) {
  return new Promise(function (resolve, reject) {
    axios.post(process.env.ROOT_API + 'admin/vendor', JSON.stringify(merchant), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Merchant Item update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}

export function getVendorOrders(query) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/vendor/orders?' + query, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log("get Vendor Order List");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to get vendor orders");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getVendorOrder(id) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.get(process.env.ROOT_API + 'admin/vendor/order?id=' + id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("get Vendor Order");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to get vendor order");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function updateVendorOrder(order) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.post(process.env.ROOT_API + 'admin/vendor/order', JSON.stringify(order), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("update Vendor Order");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update vendor order");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}

export function deleteVendorOrder(id) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.delete(process.env.ROOT_API + 'admin/vendor/order?id=' + id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("update Vendor Order");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update vendor order");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function sendVendorOrder(id) {
  return new Promise(function (resolve, reject) {
    console.log("Pleacing Order ")
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/vendor/order/send?id=' + id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log("get Vendor Order");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to get vendor order");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function sendMerchantVendorOrder(id) {
  return new Promise(function (resolve, reject) {
    console.log("Pleacing Order ")
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'merchant/vendor/order/send?id=' + id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log("get Vendor Order");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to get vendor order");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function completeVendorOrder(id) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/vendor/order/complete?id=' + id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log("get Vendor Order");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to get vendor order");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getVendorReport(type) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/vendor/report?type='+type, {
      responseType: 'blob',
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        EventBus.$emit("showLoading", false);

        console.log(response);
        resolve(response);
      })
      .catch(function(error) {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      })
  })
}
export function updateVendorBulk(list) {
  return new Promise(function(resolve, reject){
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'admin/vendors/bulk', JSON.stringify(list), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response){
      EventBus.$emit("showLoading", false);
      let data = response.data;
      // console.log("updateProductBulk")
      // console.log(data);
      resolve(data);
    }).catch(function(error){
      EventBus.$emit("showLoading", false);
      errorHandler(error);
      reject(error)
    })

  })
}
export function createNewVendor() {
  let newItem = {
    id:0,
    type:'',
    title:'',
    address:'',
    postCode:'',
    email:'',
    contact:'',
    description:'',
    edit:true,
    emails:[],
    ccEmails:[],
  }
  return newItem;
}


export function createNewVendorOrder(vendorId) {
  let newOrder = {
    id:0,
    vendorId:vendorId,
    totalPrice:0,
    tax:0,
    amount:0,
    finalDue:0,
    poNumber:'',
  }
  return newOrder;
}

export function createNewVendorOrderItem(product) {
  let newOrderItem = {
    id:0,
    title:product.title,
    vendorId:product.vendorId,
    productId: product.id,
    price:0,
    amount:1,
    totalPrice:0,
    tax:0,
    taxRate:product.taxRate,
    finalDue:0,
  }
  return newOrderItem;
}

export function vendorOrderStatusString(item) {
  if(item.confirmed == true) {
    return '확정';
  }
  if(item.state == 0) {
    return '생성';
  } else if(item.state == 10) {
    return '전송';
  }

}



// WEBPACK FOOTER //
// ./src/api/vendors.js